import { render, staticRenderFns } from "./BlogQuoteControl.vue?vue&type=template&id=243302dd"
import script from "./BlogQuoteControl.vue?vue&type=script&lang=js"
export * from "./BlogQuoteControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports